export const isArweaveURL = (url: string) => {
  return url.includes('arweave.net') || url.includes('arweave.rocks');
};
